import React from "react";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Toaster } from "react-hot-toast";
//@ts-ignore
import { createRoot } from "react-dom/client";
import "./index.css";

const rootElement: any = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <>
    <App />
    <Toaster position="top-right" />
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
